// NOTE: plain `xlsx` (SheetJS Community Edition) ignores cell styles on
// write - centering the title needs `xlsx-js-style`, a drop-in replacement
// with the same API. Install it with: npm install xlsx-js-style
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';

const ExportButtons = ({ data, fileName = 'export', title, boldLastNRows = 0 }) => {
  const cleanData = (rows) => {
    return rows.map((row) => {
      const cleaned = {};
      Object.keys(row).forEach((key) => {
        if (key.includes("_id_fk")) return;
        if (row[key] === null || row[key] === undefined) return;
        cleaned[key] = row[key];
      });
      return cleaned;
    });
  };
  const exportToExcel = () => {
    const formattedData = cleanData(data);

    let worksheet;

    if (title) {
      // Row 1: the title (e.g. consignee name), spanning the full width.
      // Row 2 onward: the normal header + data rows.
      worksheet = XLSX.utils.aoa_to_sheet([[title]]);
      XLSX.utils.sheet_add_json(worksheet, formattedData, { origin: 'A2' });

      const columnCount = formattedData.length > 0 ? Object.keys(formattedData[0]).length : 1;
      worksheet['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: Math.max(columnCount - 1, 0) } },
      ];

      // Center the title within the merged row.
      worksheet['A1'].s = {
        alignment: { horizontal: 'center', vertical: 'center' },
        font: { bold: true },
      };
    } else {
      worksheet = XLSX.utils.json_to_sheet(formattedData);
    }

    // Bold the trailing rows (e.g. the totals row appended after the data).
    if (boldLastNRows > 0 && formattedData.length > 0) {
      const headerRowIndex = title ? 1 : 0; // row index of the column headers
      const columnCount = Object.keys(formattedData[0]).length;
      const firstBoldDataRow = formattedData.length - boldLastNRows;

      for (let r = firstBoldDataRow; r < formattedData.length; r++) {
        const rowIndex = headerRowIndex + 1 + r; // +1 to skip the header row itself
        for (let c = 0; c < columnCount; c++) {
          const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c });
          if (worksheet[cellRef]) {
            worksheet[cellRef].s = {
              ...(worksheet[cellRef].s || {}),
              font: { bold: true },
            };
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(fileData, `${fileName}.xlsx`);
  };

  return (
    <button className="btn btn-export btn-sm" onClick={exportToExcel}><i className="ri-file-excel-2-fill"></i> Export</button>
  );
};

export default ExportButtons;